import React from 'react';
import { Typography, Grid, Card, CardContent, TextField, MenuItem, CardActions, Button } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { MaskTelefone } from '../../../utils/mask';
import { formatTel } from '../../../utils/format';
import { withSnackbar } from 'notistack';
import Email from 'validator/lib/isEmail';
import { ReCaptcha } from 'react-recaptcha-google';

// services
import ContatoAPI from '../../../services/api/Contato';

//css
import './contato.css';

const assuntos = [
	{
		nome:'Loja',
	},
	{
		nome:'Estacionamento',
	},
	{
		nome:'Cinema',
	},
	{
		nome:'Banheiro',
	},
	{
		nome:'Praça de alimentação',
	},
	{
		nome:'Sugestões',
	},
]


class Contato extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
		this.verifyCallback = this.verifyCallback.bind(this);
	}
	state = {
		nome: "",
		email: "",
		celular: "",
		assunto: "",
		mensagem: "",

		isNome: false,
		isEmail: false,
		isCelular: false,
		isAssunto: false,
		isMensagem: false,
		isCaptcha: false,

		loading: false,

		validation_id: null,
	}

	Submit = (event) => {
		event.preventDefault();
		const { enqueueSnackbar } = this.props;
		const { nome, email, celular, assunto, mensagem, validation_id } = this.state;
		this.setState({
			isNome: false,
			isEmail: false,
			isCelular: false,
			isAssunto: false,
			isMensagem: false,
			isCaptcha: false });
		if (nome === '') {
			this.setState({ isNome: true }, () => enqueueSnackbar('Preencha o campo de nome'));
			return;
		}
		if (!Email(email)) {
			this.setState({ isEmail: true }, () => enqueueSnackbar('Digite um email válido!'));
			return;
		}
		if (celular === '') {
			this.setState({ isCelular: true }, () => enqueueSnackbar('Preencha o campo de telefone'));
			return;
		}
		if (assunto === '') {
			this.setState({ isAssunto: true }, () => enqueueSnackbar('Selecione um assunto'));
			return;
		}
		if (mensagem === '') {
			this.setState({ isMensasgem: true }, () => enqueueSnackbar('Preencha o campo de mensagem'));
			return;
		}
		if (validation_id === null) {
			this.setState({ isCaptcha: true }, () => enqueueSnackbar('Recapcha não resolvido!'));
			return;
		}

		this.setState({ loading:true }, () => enqueueSnackbar("Aguarde enviando.."));
		let forms = {
			nome: nome,
			email: email,
			celular: celular,
			assunto: assunto,
			mensagem: mensagem,
		}

		ContatoAPI.mensagem(forms)
					.then(res => {
						res.json().then(res => {
							if (res.msg) {
								this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
								return;
							}
							this.setState({ loading:false,
											nome: "",
											email: "",
											celular: "",
											assunto: "",
											mensagem: "", }, () => enqueueSnackbar('Mensagem enviada com sucesso!'))
						})
					}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel enviar a menasgem, tente novamente mais tarde.')))

		return;

	}

	componentDidMount() {
		if (this.captchaDemo) {
			this.captchaDemo.reset();
		}
	}
	onLoadRecaptcha() {
		if (this.captchaDemo) {
			this.captchaDemo.reset();
		}
	}
	verifyCallback(recaptchaToken) {

		this.setState({validation_id: recaptchaToken});

	}

    render() {
		const { nome, email, celular, assunto, mensagem,
				isNome, isEmail, isCelular, isAssunto, isMensagem,
				loading, isCaptcha } = this.state;
		const { informacoes } = this.props;
        return (
				<div className="app_content_page" >
					<Helmet>
						<title>Fale Conosco</title>
						<meta name="description" content="Helmet application" />
					</Helmet>
					<div className="app_content_page__title_body" >
						<div className="title_body__content" >
							<Typography variant="h5" >Fale Conosco</Typography>
						</div>
					</div>
					<div className="pre_header" >
						<div className="pre_header__body" >
							<Typography variant="h5" >Tire suas dúvidas</Typography>
							<Typography variant="h5" >ou nos envie sugestões</Typography>
						</div>
					</div>
					<div className="app_content_page__row form_contato" >
						<Grid container spacing={16} >
							<Grid item xs={12} md={8} >
								<form onSubmit={this.Submit} >
									<Card>
										<CardContent >
											<Grid container spacing={32} >
												<Grid item md={12} xs={12} >
													<Typography variant="body2" >Campos Obrigatórios ( * )</Typography>
												</Grid>
												<Grid item xs={12} md={6} >
													<TextField
														label="Nome (*)"
														value={nome}
														error={isNome}
														onChange={(e) => this.setState({ nome: e.target.value })}
														fullWidth
														variant="outlined"
													/>
												</Grid>
												<Grid item xs={12} md={6} >
													<TextField
														label="Email (*)"
														value={email}
														error={isEmail}
														onChange={(e) => this.setState({ email: e.target.value })}
														fullWidth
														variant="outlined"
													/>
												</Grid>
												<Grid item xs={12} md={6} >
													<TextField
														label="Celular (*)"
														InputProps={{
															inputComponent: MaskTelefone,
														}}
														value={celular}
														error={isCelular}
														onChange={(e) => this.setState({ celular: e.target.value })}
														fullWidth
														variant="outlined"
													/>
												</Grid>
												<Grid item xs={12} md={6} >
													<TextField
														select
														label="Assunto (*)"
														value={assunto}
														error={isAssunto}
														onChange={(e) => this.setState({ assunto: e.target.value })}
														variant="outlined"
														fullWidth
													>
														{assuntos.map((a,k) => <MenuItem key={k} value={a.nome}>
															{a.nome}
														</MenuItem>)}
													</TextField>
												</Grid>
												<Grid item xs={12} md={12} >
													<TextField
														label="Mensagem (*)"
														value={mensagem}
														error={isMensagem}
														multiline
														rows="6"
														onChange={(e) => this.setState({ mensagem: e.target.value })}
														fullWidth
														variant="outlined"
													/>
												</Grid>
											</Grid>
										</CardContent>
										<CardActions style={{paddingLeft: 12, paddingRight: 12}} >
											<Grid container spacing={16} >
												<Grid item xs={12} md={6} >
													<Button variant="contained" type="submit" disabled={loading} >Enviar</Button>
												</Grid>
												<Grid item xs={12} md={6} className={`column__captcha ${isCaptcha === true ? 'error_captcha' : ''}`} >
													<ReCaptcha
														ref={(el) => {this.captchaDemo = el;}}
														size="normal"
														render="explicit"
														theme="light"
														hl="pt-BR"
														sitekey="6Len2LUUAAAAALf_Np5t0wsaBBrYdazTMP1Q7RmH"
														onloadCallback={this.onLoadRecaptcha}
														verifyCallback={this.verifyCallback}
													/>
												</Grid>
											</Grid>
										</CardActions>
									</Card>
								</form>
							</Grid>
							<Grid item xs={12} className="column_information" md={4} >
								<Grid container spacing={16} >
									<Grid item xs={12} md={12} >
										<Typography variant="h5" >TELEFONE:</Typography>
										<Typography variant="body1" >{formatTel(String(informacoes.telefone))}</Typography>
									</Grid>
									<Grid item xs={12} md={12} >
										<Typography variant="h5" >HORÁRIO DE FUNCIONAMENTO</Typography>
									</Grid>
									<Grid item xs={12} md={12} >
										<Typography variant="h6" >Segunda a sábado:</Typography>
										<Typography variant="body2" >Lojas: {informacoes.func_seg_sab_loja}</Typography>
										<Typography variant="body2" >Alimentação e Lazer: {informacoes.func_seg_sab_lazer}</Typography>
									</Grid>
									<Grid item xs={12} md={12} >
										<Typography variant="h6" >Domingo:</Typography>
										<Typography variant="body2" >Lojas: {informacoes.func_domingo_loja}</Typography>
										<Typography variant="body2" >Alimentação e Lazer: {informacoes.func_domingo_lazer}</Typography>
									</Grid>
									{/* <Grid item xs={12} md={12} >
										<Typography variant="h6" >VAGAS DE EMPREGO:</Typography>
										<Typography variant="body2" >Fique por dentro de todas as oportunidades.</Typography>
										<Typography variant="body2">Clique no botão abaixo para ver as vagas disponiveis.</Typography>
									</Grid>
									<Grid item xs={12} md={12} >
										<Button variant="contained" >Ver vagas</Button>
									</Grid> */}
								</Grid>
							</Grid>
						</Grid>
					</div>
				</div>
        );
    }
}

export default withSnackbar(Contato);



// WEBPACK FOOTER //
// ./src/web/pages/contato/index.js